import { Button } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { getEsaFundName } from "@outschool/ui-auth";
import { Banner } from "@outschool/ui-legacy-component-library";
import React from "react";

import { SHOULD_DISABLE_ONGOING_ENROLLMENTS_WITH_CLASSWALLET } from "../../../shared/Env";

type Props = {
  onExitSession: () => void;
  esaState?: string;
};

export default function EsaBanner({ onExitSession }: Props) {
  const { t } = useTranslation("client\\components\\banners\\EsaBanner");

  return (
    <Banner data-test-id="esa-banner">
      {SHOULD_DISABLE_ONGOING_ENROLLMENTS_WITH_CLASSWALLET
        ? t(
            'Use ClassWallet funds to enroll in {{esaProgram}} eligible classes, except the "ongoing" format.',
            { esaProgram: getEsaFundName() }
          )
        : t(
            "Use your ClassWallet funds to enroll in {{esaProgram}} eligible classes.",
            { esaProgram: getEsaFundName() }
          )}
      &nbsp;
      <Button
        variant="link"
        sx={{
          alignSelf: "start",
          fontSize: "1em"
        }}
        onClick={onExitSession}
      >
        {t("Exit ClassWallet Session")}
      </Button>{" "}
      {t("to pay by other methods.")}
    </Banner>
  );
}
